import CryptoJS from "crypto-js";

/**
 * Encrypt data before sending an AJAX call
 * @param {*} data 
 * @returns 
 */
export const Encryption = (data) => {
	return { data: CryptoJS.AES.encrypt(data, process.env.REACT_APP_ENCRYPTION_KEY).toString() };
}

/**
 * Decrypt data received from AJAX call
 * @param {*} data 
 * @returns 
 */
export const Decryption = (data) => {
	return JSON.parse(CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8));
}

/**
 * Encrypt string values
 * @param {string} string 
 * @returns 
 */
export const EncryptionString = (string = '') => {
	return CryptoJS.AES.encrypt(string, process.env.REACT_APP_ENCRYPTION_STRING_KEY).toString();
}

/**
 * 
 * @param {string} string 
 * @returns 
 */
export const DecryptionString = (data) => {
	return CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENCRYPTION_STRING_KEY).toString(CryptoJS.enc.Utf8);
}